import { slugify } from "../utils/slugify";

export type ProductCategory = "bags" | "shoes";

export type Product = {
  id: string;
  image: string;
  title: string;
  price: string;
  priceValue: number;
  category: ProductCategory;
  isNew?: boolean;
  featured?: boolean;
  sizes?: string[];
  stock?: number;
  description?: string;
};

export const CATEGORY_LABELS: Record<ProductCategory, string> = {
  bags: "Sacs",
  shoes: "Chaussures",
};

export function buildProductSlug(product: Product) {
  return `${slugify(product.title)}-${product.id}`;
}

export function getProductBySlug(products: Product[], slug: string) {
  const exactMatch = products.find(
    (product) => buildProductSlug(product) === slug
  );
  if (exactMatch) return exactMatch;

  return products.find((product) => slugify(product.title) === slug);
}
